export default "__VITE_ASSET__KVHUb9h8__"